// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page layout (well-attachments-dialog pattern) ───────────── */
.rh-page-wrapper {
    background-color: #f0f0f0;
    min-height: 100%;
    padding: 0 24px 24px;
}

.rh-page-title {
    background-color: #f0f0f0;
    color: #0b2d71;
    font-size: 1.25rem;
    font-weight: 700;
    text-align: center;
    padding: 12px 0 8px;
}

.rh-card {
    border-radius: 4px;
    padding: 0;
    overflow: hidden;
}

/* ── Tabs — project-details style ────────────────────────────── */
.nav-tabs {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dbdcdd;
    margin-bottom: 0;
    padding: 0 8px;
    gap: 4px;
    list-style: none;
}

.nav-link.tab-label {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 0.9rem;
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
    color: #0066b2 !important;
    border: none !important;
    border-bottom: 4px solid transparent !important;
    background: transparent !important;
    text-decoration: none !important;
    white-space: nowrap;
    border-radius: 0 !important;
}

.nav-link.tab-label:hover {
    color: #0b2d71 !important;
    background: #f0f4ff !important;
    text-decoration: none !important;
    border-bottom: 4px solid #cbd6ef !important;
}

.nav-link.tab-label.active {
    color: #0b2d71 !important;
    font-weight: 700 !important;
    border-bottom: 4px solid #0b2d71 !important;
    background: transparent !important;
    text-decoration: none !important;
}

/* Tab content styling */
.tab-content {
    padding-top: 0;
    padding-bottom: 0;
}

.tab-pane.active {
    border: none;
    padding: 0;
}

/* ── Section header banner (.float-none in sub-components) ──────── */
legend {
    color: #0b2d71;
    font-size: 1rem;
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
}

.card-header {
    background-color: #0b2d71;
    color: white;
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
}

/* Form labels */
.col-form-label {
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
    color: #0b2d71;
}

/* Input groups */
.input-group-text {
    background-color: #f8f9fa;
    border-color: #ced4da;
}

/* Result labels */
.result-lable {
    background-color: #f8f9fa;
    font-weight: 500;
}

/* Fieldset border */
fieldset.border {
    border: 1px solid #dee2e6 !important;
}

/* Card styling */
.card {
    margin-bottom: 20px;
    border: 1px solid #dee2e6;
}

.card-body {
    padding: 1.5rem;
}

/* Sub-components inherit white bg from .rh-card */
.container-fluid {
    background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/rheological-hierarchy/rheological-hierarchy.component.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;IACI,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,+CAA+C;IAC/C,kCAAkC;IAClC,gCAAgC;IAChC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,2CAA2C;IAC3C,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA,sEAAsE;AACtE;IACI,cAAc;IACd,eAAe;IACf,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,oCAAoC;AACxC;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA,kDAAkD;AAClD;IACI,6BAA6B;AACjC","sourcesContent":["/* ── Page layout (well-attachments-dialog pattern) ───────────── */\n.rh-page-wrapper {\n    background-color: #f0f0f0;\n    min-height: 100%;\n    padding: 0 24px 24px;\n}\n\n.rh-page-title {\n    background-color: #f0f0f0;\n    color: #0b2d71;\n    font-size: 1.25rem;\n    font-weight: 700;\n    text-align: center;\n    padding: 12px 0 8px;\n}\n\n.rh-card {\n    border-radius: 4px;\n    padding: 0;\n    overflow: hidden;\n}\n\n/* ── Tabs — project-details style ────────────────────────────── */\n.nav-tabs {\n    display: flex;\n    justify-content: center;\n    border-bottom: 1px solid #dbdcdd;\n    margin-bottom: 0;\n    padding: 0 8px;\n    gap: 4px;\n    list-style: none;\n}\n\n.nav-link.tab-label {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n    color: #0066b2 !important;\n    border: none !important;\n    border-bottom: 4px solid transparent !important;\n    background: transparent !important;\n    text-decoration: none !important;\n    white-space: nowrap;\n    border-radius: 0 !important;\n}\n\n.nav-link.tab-label:hover {\n    color: #0b2d71 !important;\n    background: #f0f4ff !important;\n    text-decoration: none !important;\n    border-bottom: 4px solid #cbd6ef !important;\n}\n\n.nav-link.tab-label.active {\n    color: #0b2d71 !important;\n    font-weight: 700 !important;\n    border-bottom: 4px solid #0b2d71 !important;\n    background: transparent !important;\n    text-decoration: none !important;\n}\n\n/* Tab content styling */\n.tab-content {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.tab-pane.active {\n    border: none;\n    padding: 0;\n}\n\n/* ── Section header banner (.float-none in sub-components) ──────── */\nlegend {\n    color: #0b2d71;\n    font-size: 1rem;\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n}\n\n.card-header {\n    background-color: #0b2d71;\n    color: white;\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n}\n\n/* Form labels */\n.col-form-label {\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n    color: #0b2d71;\n}\n\n/* Input groups */\n.input-group-text {\n    background-color: #f8f9fa;\n    border-color: #ced4da;\n}\n\n/* Result labels */\n.result-lable {\n    background-color: #f8f9fa;\n    font-weight: 500;\n}\n\n/* Fieldset border */\nfieldset.border {\n    border: 1px solid #dee2e6 !important;\n}\n\n/* Card styling */\n.card {\n    margin-bottom: 20px;\n    border: 1px solid #dee2e6;\n}\n\n.card-body {\n    padding: 1.5rem;\n}\n\n/* Sub-components inherit white bg from .rh-card */\n.container-fluid {\n    background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
